import { Injectable } from '@angular/core';


import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap, filter, take, switchMap, catchError } from 'rxjs/operators';

import {
  SetProblems, GetProblems, getProblemsLength, Heartbeat,
  SetNoMapLocation, GetMenuOption, DelayedActionBy1, DelayedAction, GetDashboardView
} from '../../state-management';
import { Problem } from '../../models/problem';
import { of } from 'rxjs';

@Injectable()
export class DashboardGuard  {
  constructor(private store: Store<{}>) {
  }

  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
    }

  checkStore(): Observable<boolean> {

    return this.store.select(getProblemsLength)
      .pipe(
        tap(problems => {
          this.store.dispatch(new GetProblems());
          this.store.dispatch(new GetMenuOption());
          this.store.dispatch(new GetDashboardView());

          // this.store.dispatch(new DelayedAction([
          //   new Heartbeat({
          //     actions: [
          //       new SetProblems([]),
          //       new SetNoMapLocation(false),
          //       new DelayedActionBy1([
          //         new Heartbeat({
          //           actions: [
          //             new DelayedActionBy1([
          //               new DelayedActionBy1([
          //                 new GetMenuOption(),
          //                 new DelayedActionBy1([
          //                   new GetProblems()
          //                 ])
          //               ])
          //             ])
          //           ], retryCount: 0, maxRetry: 3
          //         })
          //       ])
          //     ], retryCount: 0, maxRetry: 3
          //   })
          // ]));
        })
      );
  }
}
